/**
 * Charge une matiere dans le configurateur present sur la page.
 *
 * Sert au nuancier comme aux cartes Nouveautes. Les elements enveloppes sont
 * d'abord des liens vers la variante : sans JS, ou sur une page sans
 * configurateur, le clic mene a la fiche produit deja configuree. Le composant
 * declenche un vrai clic sur le radio correspondant, VariantSelects prend le
 * relais.
 *
 * Le nuancier et les Nouveautes chargent tous deux ce fichier sur l'accueil :
 * tout est enveloppe dans une fonction qui s'arrete si le composant existe
 * deja, sinon la seconde declaration de classe leve une erreur.
 */
(() => {
  if (customElements.get('go-configurator-link')) return;

  class GoConfiguratorLink extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

      const source = event.target.closest('[data-option-value-id]');
      if (!source || !this.contains(source)) return;

      const input = document.querySelector(
        `input[data-option-value-id="${CSS.escape(source.dataset.optionValueId)}"]`
      );
      if (!input) return;

      event.preventDefault();

      const target = input.closest('.shopify-section') || input;

      const steps = input.closest('go-config-steps');
      const group = input.closest('.go-group[data-family]');
      if (steps && group && group.dataset.family) steps.apply(group.dataset.family);

      input.click();

      const destination = target.getBoundingClientRect().top + window.scrollY;
      if (window.goSmoothScrollTo) {
        window.goSmoothScrollTo(destination);
      } else {
        target.scrollIntoView({ block: 'start' });
      }
    }
  }

  customElements.define('go-configurator-link', GoConfiguratorLink);
})();
